exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "canvas[data-v-8a7b1d34] {\n  background: no-repeat center / cover;\n  border: 1px solid #000;\n  transition: width 0.3s, height 0.3s;\n}\n", ""]);
